<template>
	<div :class="[
		'todays-events',
		{ 'active': this.isActive }
	]">
		<div ref="todays-events-content" :class="[
			'todays-events-content', 
			{ 'active': this.contentActive },
			{ 'visible': this.contentVisible }
		]">
			<div ref="events-info" class="events-info">
				<h2 class="text">
					{{ this.content.title }}
				</h2>
				<h3 class="text light grey" v-if="this.content.showDate"> {{ this.today }} </h3>
				<div v-for="item in this.content.listItems" :key="item.eventTitle" class="event-container">
					<h4 class="text light mint">{{item.eventType}}</h4>
					<h3 class="text title"> {{ item.eventTitle }} </h3>
					<h4 v-if="item.location" class="text light grey">{{item.locationName}}</h4>
					<h4 v-if="!item.endTime" class="text light grey">{{item.startTime}}</h4>
					<h4 v-if="item.endTime" class="text light grey">{{item.startTime}} - {{item.endTime}}</h4>
					<h4 class="text light description">{{item.description}}</h4>
					<div class="event-links">
						<h4 v-if="item.location" class="text light grey" v-on:click="selectEvent(item.location.MapID)">Map Location</h4>
						<a v-if="item.eventLink" :href="item.eventLink" target="_blank" class="text light grey">Purchase Tickets</a>
					</div>
				</div>
			</div>
			<div ref="shadow" class="popup-shadow"></div>
		</div>
		
		<input type="image" :src="closeSvg" :class="['close-btn', {'show' : this.closeButtonVisible}]" v-on:click="hide()">
	</div>
</template>

<script>
	import { gsap } from 'gsap';
	import { DateFormat } from "@/DateFormat.js";

	export default {
		name: "TodaysEvents",
		data: function() {
			return {
				sharedStore: window.store,
				today: DateFormat.now("#DDDD#, #MMMM# #D##th#"),
				closeSvg: require('../assets/ui/close-x.svg'),
				processedContent: {},
				timeline: new gsap.timeline(),
				isActive: false,
				iconVisible: true,
				contentActive: false,
				contentVisible: false,
				closeButtonVisible: false
			}
		},
		mounted: function() {
			this.processTodaysEventsData(this.sharedStore.state.todaysEventsData);
			// auto open when first landing on page
			if (this.content.autoOpen && this.content.listItems.length) {
				setTimeout(() => {
					this.show();
				}, 500);
			}
		},
		computed: {
			content: function() {
				return this.processedContent;
			},
		},
		watch: {
			
		},
		methods: {
			toggleVisible: function() {
				if (this.isActive === true) {
					this.hide();
				} else {
					this.show();
				}
			},
			hide: function() {
				this.timeline.kill();
				this.timeline = new gsap.timeline();

				this.isActive = false;

				let target = {
					width: this.$refs["todays-events-content"].clientWidth,
					height: this.$refs["todays-events-content"].clientHeight,
				}

				this.contentVisible = false;
				this.closeButtonVisible = false;

				this.timeline.fromTo(this.$refs["todays-events-content"], {
					width: target.width,
					height: target.height
				}, {
					duration: 0.5,
					width: "40px",
					height: "40px"
				}, 0.2);
				this.timeline.call(() => {
					this.contentActive = false;
					this.iconVisible = true;
				});
			},
			show: function() {
				this.timeline.kill();
				this.timeline = new gsap.timeline();

				this.isActive = true;

				this.iconVisible = false;
				this.contentActive = true;
				this.closeButtonVisible = true;
				this.$refs["todays-events-content"].style.width = "auto";
				this.$refs["todays-events-content"].style.height = "auto";
				let target = {
					width: this.$refs["todays-events-content"].clientWidth,
					height: this.$refs["todays-events-content"].clientHeight,
				}

				if (this.$refs["events-info"].clientHeight > 600) { //only add the shadow if the div is scrollable (i.e. greater than max height of 600)
					this.timeline.to(this.$refs.shadow, {
						height: target.height,
						duration: 0.5
					}, 0.2);
				} else {
					this.timeline.to(this.$refs.shadow, {
						opacity: 0,
						duration: 0.1
					}, 0.1);
				}

				

				this.timeline.fromTo(this.$refs["todays-events-content"], {
					width: "40px",
					height: "40px"
				}, {
					duration: 0.5,
					width: target.width,
					height: target.height
				}, 0.2);
				this.timeline.call(() => {
					this.contentVisible = true;
				});
			},
			processTodaysEventsData: function(content) {
				this.processedContent = content;
			},
			selectEvent: function(prefix) {
				this.$emit("selectEvent", prefix);
			}
		}
	}
</script>

<style scoped lang="scss">
	.todays-events {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 50vw;
		padding: 15px 28px 0;
		color: #ffffff;
		font-size: 1rem;
    pointer-events: none;
    min-width: 350px;
    max-height: 60vh;
    opacity: 0;

		transition: 0.2s;
		transition-delay: 0.7s;

		&.active {
			transition-delay: 0s;
      pointer-events: all;
      transform: translate(-50%, 120px);
      left: 50%;
      opacity: 1;
		}

		.todays-events-content {
			width: 0px;
			height: 0px;
      max-height: 60vh;
      text-align: center;
      overflow-y: scroll;
      overflow-x: hidden;

      .popup-shadow {
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 90%, rgba(0, 0, 0, 0.7) 99%);
        position: fixed;
        top: 15px;
        pointer-events: none;
        width: 85%;
        height: 100%;
        left: 50%;
        overflow: hidden;
        transform: translateX(-50%);
      }
		}
	}

  .todays-events-content {
		position: relative;
		padding: 15px;

    .text {
      color: white;
      margin: 0;

      &.light {
        font-weight: 500;
      }
      &.grey {
        color: #9F9E9E;
      }
      &.mint {
        color: rgb(103, 199, 180);
        margin-bottom: 5px;
      }
    }

    .description {
      margin: 10px 0;
    }

		>* {
			transition: 0.2s;
			opacity: 0;
		}

		&.visible {
			>* {
				opacity: 1;
			}
		}

		&.active {
      border: 1px solid white;
      background: rgb(25, 25, 25);
		}

    .event-container{
      margin-top: 20px;
      text-align: left;
      padding-bottom: 20px;
    }

    .event-container:not(:last-child) {
      border-bottom: 1px solid #9F9E9E;
    }

    .event-links {
      display: flex;
      justify-content: space-between;
      text-decoration: underline;
      color: #9F9E9E;
    }
  }

  .close-btn {
		position: absolute;
		top: 0px;
		right: 15px;
		z-index: 50;
		width: 30px;
		height: 30px;
		outline: none;
		padding: 0px;
		border-radius: 30px;
		pointer-events: auto;
    visibility: hidden;

    &.show {
      transition-delay: 0.8s;
      visibility: visible;
    }
	}
</style>